import userReducer from "../ducks/user";
import customerReducer from "../ducks/customer";

const reducers = {
  userReducer,
  customerReducer,
};

export default reducers;
